import { initializeApp, getApps } from 'firebase/app'
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth'

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_PROJECT + '.firebaseapp.com',
  databaseURL: `https://${import.meta.env.VITE_FIREBASE_PROJECT}.firebaseio.com`,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT,
  storageBucket: import.meta.env.VITE_FIREBASE_PROJECT + '.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

let firebaseApp: ReturnType<typeof initializeApp> | null = null

function hasFirebaseConfig() {
  return [
    firebaseConfig.apiKey,
    firebaseConfig.projectId,
    firebaseConfig.messagingSenderId,
    firebaseConfig.appId
  ].every((value) => typeof value === 'string' && value.trim().length > 0)
}

export function isFirebaseEnabled() {
  return hasFirebaseConfig()
}

export function getOrInitFirebase() {
  if (!hasFirebaseConfig()) {
    throw new Error('Firebase configuration is missing or invalid.')
  }

  if (!firebaseApp && !getApps().length) {
    firebaseApp = initializeApp(firebaseConfig)
  } else if (!firebaseApp) {
    firebaseApp = getApps()[0]
  }
  return firebaseApp
}

export async function getPersistentAuth() {
  getOrInitFirebase()
  const auth = getAuth()
  await setPersistence(auth, browserLocalPersistence)
  return auth
}
